// Web 接入
import { devConf, prodConf } from "@/constants/abConfig";
import { isSpiderClient } from "@/utils/isSpider";
import { env } from "@/utils/request";
import gdABTest from "@gaoding/gd-abtest";
import { TrackerInitFailed } from "./index";

let isInit = false;
const resloveList = [];

export function abTestInit({ user_id, device_id, is_login, org_id }) {
  gdABTest.init({
    user_id: user_id, // 客户端能唯一标识用户的ID，必填
    device_id: device_id, // 客户端的设备ID，必填
    is_login: String(is_login), // 用户是否登录 0：未登录，1：登录，必填
    org_id: org_id,
    ...(env === "prod" || env === "stage" ? prodConf : devConf),
  });

  // 获取实验数据
  // gdABTest.getExps();
  isInit = true;

  resloveList.forEach((rs) => {
    rs();
  });

  return gdABTest;
}

/**
 * 获取实验变量
 * @param {string} key 实验的变量
 * @param {string} defaultValue 默认值（实验结束后，或者实验获取失败，返回默认值）
 * @returns {Promise<string>} 实验变量的值
 */
export async function getExpsValue(...args) {
  // 如果埋点初始化失败，则直接返回默认值
  if (TrackerInitFailed) {
    return args[1];
  }

  // 爬虫、埋点脚本加载失败场景，直接返回默认值
  if (isSpiderClient() || !window.gdTracker) {
    return args[1];
  }

  if (isInit) {
    return gdABTest.getValue(...args);
  } else {
    return new Promise((resolve, reject) => {
      try {
        resloveList.push(async () => {
          const value = await gdABTest.getValue(...args);
          resolve(value);
        });
      } catch (error) {
        reject(error);
      }
    });
  }
}
